import { helpers, React, ts, ui } from '_core';

import { Params } from './types';
import { prepareRhDataTable } from '../../common/utils/signal-utils';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  returns: string;
  fullScreen: boolean;
  frequency: ts.enums.FREQUENCY_ENUM;
  params: Params;
  title: string;
  setExternalEmbed: (_json: ts.types.analysis.EmbedChartData) => void;
  subtitle?: string;
};

const Chart = ({
  id,
  readOnly,
  loadWidgetData,
  returns,
  fullScreen,
  frequency,
  params,
  title,
  subtitle,
  setExternalEmbed,
}: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: returns,
        },
      });

      if (response) setData(prepareRhDataTable(response.data, frequency));
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (returns && params.scale) loadData();
    return () => setData(null);
  }, [returns, params.scale]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      exportSubTitle={subtitle}
      setExternalEmbed={setExternalEmbed}
      numberFormat="#.##%"
      showEndValueLabel
    />
  );
};

export default Chart;
